import React, { useEffect, useState } from "react";
import { getCustomerProfile, updateCustomerPhone } from "../../../../api"
import styles from "./EditInfo.module.css";

const e164ish = (value) => {
  if (!value) return "";
  let s = String(value).trim();
  if (s.startsWith("00")) s = `+${s.slice(2)}`;
  s = s.replace(/[^\d+]/g, "");
  if (s.startsWith("+")) {
    const rest = s.slice(1).replace(/\D/g, "");
    return `+${rest}`;
  }
  return s.replace(/\D/g, "");
};

const isLikelyValidPhone = (value) => {
  return /^\+?\d{7,20}$/.test(value);
};

export default function EditInfo() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [serverError, setServerError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [phone, setPhone] = useState("");
  const [initialPhone, setInitialPhone] = useState("");
  const [name, setName] = useState("");

  useEffect(() => {
    const load = async () => {
      try {
        const res = await getCustomerProfile();
        const p = res?.data?.phone || "";
        setPhone(p);
        setInitialPhone(p);
        const fn = res?.data?.first_name || "";
        const ln = res?.data?.last_name || "";
        setName(`${fn} ${ln}`.trim());
      } catch (e) {
        console.error(e);
        setServerError("Failed to load your profile. Please refresh.");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const handleNormalize = () => {
    const normalized = e164ish(phone);
    setPhone(normalized);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setServerError("");
    setSuccessMsg("");

    const normalized = e164ish(phone);
    if (!isLikelyValidPhone(normalized)) {
      setServerError("Please enter a valid phone number (7–20 digits, optional leading +).");
      return;
    }

    if (normalized === initialPhone) {
      setServerError("That’s already your current phone number.");
      return;
    }

    try {
      setSaving(true);
      await updateCustomerPhone(normalized);
      setInitialPhone(normalized);
      setSuccessMsg("Phone updated successfully.");
    } catch (err) {
      console.error(err);
      const msg =
        err?.response?.data?.error ||
        "Could not update phone right now. Please try again.";
      setServerError(msg);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className={styles.loading}>Loading…</div>;
  }

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h2 className={styles.heading}>Login &amp; Security</h2>
        {name && <p className={styles.subHeading}>Hi {name}, update your phone number below.</p>}

        {serverError && <div className={styles.alertError}>{serverError}</div>}
        {successMsg && <div className={styles.alertSuccess}>{successMsg}</div>}

        <form onSubmit={handleSubmit} className={styles.form} noValidate>
          <label htmlFor="phone" className={styles.label}>
            Phone Number
          </label>
          <input
            id="phone"
            name="phone"
            type="tel"
            inputMode="tel"
            autoComplete="tel"
            className={styles.input}
            placeholder="+9715XXXXXXXX"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            onBlur={handleNormalize}
            aria-describedby="phone-hint"
          />
          <div id="phone-hint" className={styles.hint}>
            Use digits only; add a leading “+” for country code (e.g., +971…)
          </div>

          <div className={styles.actions}>
            <button
              type="submit"
              className={styles.primaryButton}
              disabled={saving}
            >
              {saving ? "Saving…" : "Save Phone"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
